if (!customElements.get('bundle-switcher')) {
  customElements.define(
    'bundle-switcher',
    class BundleSwitcher extends HTMLElement {
      constructor() {
        super();
        this.enableBundle = (this.dataset.enableBundle === 'true');
        this.bundleData = JSON.parse(this.querySelector('#bundle-script').textContent);
        this.mediaThumbnailsFirst = this.querySelector('.product-thumbnails__item');
        this.mediaFirst = this.querySelector('.product__media');
        this.bundlePrice = this.querySelector('[data-product-price');
        this.addToCartButton = this.querySelector('[data-add-to-cart');
      };

      connectedCallback() {
        if(this.enableBundle) {
          this.switchBundle(this.bundleData[0])
        }
      }

      switchBundle(bundle) {
        this.mediaFirst.querySelector('.media__image .image').innerHTML  = `
          <img class="image__img lazyautosizes lazyloaded bundle-img" loading="lazy" src="${bundle.bundle_image}"/>
        `
        this.mediaThumbnailsFirst.querySelector('.product-thumbnails__item-image').innerHTML = `
          <img class="image__img lazyautosizes lazyloaded bundle-img" loading="lazy" src="${bundle.bundle_image}"/>
        `

        const bundleEl = document.querySelector('.bundle');
        bundleEl.innerHTML = `
          <div class="bundle-header">
            <h2 class="bundle-header__title">${bundle.title}</h2>
            <div class="bundle-header__badge">
              <strong>${bundle.badge_title}</strong> <span>${bundle.badge_subtitle}</span>
            </div>
          </div>
          <p class="bundle-description">${bundle.description}</p>
          <p class="bundle-contain">${bundle.bundle_contain}</p>

          <div class="bundle-switcher">
            <p class="bundle-swithcer__title">Select bundle</p>
            <div class="bundle-switcher__items">
              ${this.bundleData.map(bundleItem =>
                `
                  <div class="bundle-item ${bundleItem.title === bundle.title ? 'active' : ''}">
                  <div class="bundle-item__img-wrapper"><img class="bundle-item__img" loading="lazy" src="${bundleItem.bundle_image}"/></div>
                  <p class="bundle-item__title">${bundleItem.bundle_title}</p>
                  </div>
                `
              ).join('')}
            </div>
          </div>
        `;

        // Add event listeners to each bundle item
        const bundleItems = bundleEl.querySelectorAll('.bundle-item');
        bundleItems.forEach((item, index) => {
          item.addEventListener('click', () => this.switchBundle(this.bundleData[index]));
        });

        
        //Product details
        const detailsEl = document.querySelector(".product_details_acc_new .accordion__text")
        let bundlePrice = 0;
        let currencySymbol = '';
        let discountPercentage = parseInt(bundle.badge_title.slice(0, -1));
        let variantIds = []
        bundle.product_variants.map(variant => {
          currencySymbol = Array.from(variant.price)[0];
          bundlePrice += parseInt(variant.price.substring(1));
          variantIds.push(variant.id)
        })
        const decodedString = bundle.product_details
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&amp;/g, '&');

        detailsEl.innerHTML = `
          <div class="product-variant__details">
           ${decodedString}
          </div>
        `;
        //Price display
        let discountedPrice = bundlePrice * ((100 - discountPercentage) / 100);
        this.bundlePrice.innerHTML = `<span class="bundle-item-compare-at-price">${currencySymbol}${bundlePrice}</span> ${currencySymbol}${discountedPrice}`;

        //Products ids for add to cart
        this.addToCartButton.setAttribute('data-variant-ids', variantIds.join(','));
      }
    }
  )
}